/**
 * Holds a Patron invitation across sign-up and email confirmation so the
 * application is created once, after sign-in, without a second scan. The
 * server is idempotent (one open request per member and business).
 */
const KEY = "vitolier_pending_patron";
const TTL_MS = 1000 * 60 * 60 * 24 * 30;
export function holdPatronInvite(code: string) {
  try { localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() })); } catch { /* ignore */ }
}
export function readPatronInvite(): string | null {
  try {
    const p = JSON.parse(localStorage.getItem(KEY) ?? "null");
    if (!p?.code || Date.now() - p.at > TTL_MS) return null;
    return p.code as string;
  } catch { return null; }
}
export function clearPatronInvite() { try { localStorage.removeItem(KEY); } catch { /* ignore */ } }
